<template>
  <div class="firstStep" v-loading="formLoading">
    <el-form
      :model="extForm"
      :rules="rules"
      ref="ruleForm"
      label-width="60px"
      class="demo-ruleForm"
    >
      <div class="masterDataInformation">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="注册联系人："
              label-width="160px"
              prop="authUserName"
            >
              <el-input v-model="extForm.authUserName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" label-width="160px" prop="phone">
              <el-input v-model="extForm.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="信用代码："
              label-width="160px"
              prop="unifiedCreditCode"
            >
              <el-input
                v-on:blur="searInpt"
                v-model="extForm.unifiedCreditCode"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="供应商名称："
              label-width="160px"
              prop="supplierName"
            >
              <el-input
                disabled
                v-loading="loadWaite"
                v-model="extForm.supplierName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="合作单位："
              label-width="160px"
              prop="cooUnitName"
            >
              <div class="verificationCode">
                <el-input
                  disabled
                  style="width: 165px"
                  v-model="extForm.cooUnitName"
                ></el-input
                ><el-button
                  class="send"
                  @click="centerDialogVisible = true"
                  style="background: red"
                  >获取单位</el-button
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="display: flex">
            <el-form-item
              class=""
              label="验证码："
              label-width="160px"
              prop="verificationCode"
            >
              <div class="verificationCode">
                <el-input
                  style="width: 165px"
                  v-model="extForm.verificationCode"
                ></el-input
                ><el-button
                  class="send"
                  style="background: red"
                  @click="sendVerification"
                  :disabled="disabled"
                  >{{ count }}发送</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label-width="160px">
          <el-button @click="submitForms('ruleForm')">下一步</el-button>
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </div>
    </el-form>
    <el-dialog
      title="选择合作单位"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <treeBox ref="msgFormSon"></treeBox>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getTreeItem">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  registinformation,
  qryTycSearch,
  sendVerificationCode,
  checkContactByMobile,
} from "@/api/subcontractor-register";

import treeBox from "../components/cooperativeUnitTree.vue";
import { formatDate } from "@/utils";
export default {
  props: {
    extForm: {},
    subconChangeInfo: {},
    registerForm: {},
  },
  components: {
    treeBox,
  },
  data() {
    return {
      formLoading: false,
      loadWaite: false,
      count: "",
      disabled: false,
      centerDialogVisible: false,
      __resizeHandler: null,
      value: [],
      treeParams: {
        parentId: "",
        flag: 0,
        isOran: "0",
        isOrganAll: "0",
      },
      // 用户id
      // 分包商变更id
      // 分包商id
      // 注册人证件类型
      // 注册人证件号码
      // 注册邮箱
      // 法人代表授权委托书
      rules: {
        authUserName: [
          { required: true, message: "请输入姓名", trigger: "change" },
          {
            pattern: /^[\u4e00-\u9fa5]{2,18}$/,
            message: "请输入2-18个中文汉字",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1\d{10}$/,
            message: "手机号码输入错误",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
        secondaryPassword: [
          { required: true, message: "请输入确认密码", trigger: "change" },
        ],
        supplierName: [
          { required: true, message: "请输入供应商名称", trigger: "change" },
        ],
        unifiedCreditCode: [
          // /.{2,18}/
          {
            required: true,
            message: "请输入正确的信用代码",
            trigger: "change",
          },

          { max: 18, message: "长度为18位", trigger: "change" },
        ],
        cooUnitName: [
          { required: true, message: "请输入合作单位", trigger: "change" },
        ],
        verificationCode: [
          { required: true, message: "请输入验证码", trigger: "change" },
        ],
      },
    };
  },

  methods: {
    isdecimal(val) {
      let y = String(val).indexOf(".") + 1; //获取小数点的位置
      let count = String(val).length - y; //获取小数点后的个数
      if (y > 0) {
        return true;
      } else {
        return false;
      }
    },
    submitForms(formName) {
      qryTycSearch({ word: this.extForm.unifiedCreditCode }).then((res) => {
        this.loadWaite = false;
        if (res.data.code === "0") {
          this.extForm.unifiedCreditCode = "";
          this.extForm.supplierName = "";
          if (res.data.data.result) {
            const info = res.data.data.result;
            // 人员规模 staffNumRange
            this.$set(
              this.subconChangeInfo,
              "companySize",
              parseInt(info.staffNumRange)
            );
            // 成立日期
            this.$set(
              this.subconChangeInfo,
              "companySetupTime",
              formatDate(info.estiblishTime, "yyyy-MM-dd")
            );
            //fromTime Number 毫秒数 经营开始时间
            //toTime Number 毫秒数 经营结束时间
            this.$set(this.subconChangeInfo, "businessTime", [
              formatDate(info.fromTime, "yyyy-MM-dd"),
              formatDate(info.toTime, "yyyy-MM-dd"),
            ]);
            // 注册资本
            if (this.isdecimal(info.regCapital)) {
              this.subconChangeInfo.registeredCapital = info.regCapital.slice(
                0,
                info.regCapital.indexOf("万").toFixed(2)
              );
            } else {
              this.subconChangeInfo.registeredCapital = info.regCapital.slice(
                0,
                info.regCapital.indexOf("万")
              );
            }
            // actualCapital String   实收注册资金
            if (this.isdecimal(info.actualCapital)) {
              this.$set(
                this.subconChangeInfo,
                "paidInCapital",
                info.actualCapital.slice(
                  0,
                  info.regCapital.indexOf("万").toFixed(2)
                )
              );
            } else {
              this.$set(
                this.subconChangeInfo,
                "paidInCapital",
                info.actualCapital.slice(0, info.regCapital.indexOf("万"))
              );
            }
            // 企业名称
            this.extForm.supplierName = info.name;
            this.subconChangeInfo.subconName = info.name;
            // regLocation String   注册地址
            this.$set(
              this.subconChangeInfo,
              "registeredAddress",
              info.regLocation
            );
            // 经营范围
            this.$set(
              this.subconChangeInfo,
              "businessScope",
              info.businessScope
            );
            // 英文名
            this.$set(this.subconChangeInfo, "subconUsName", info.property3);
            // alias String   简称
            this.$set(this.subconChangeInfo, "subconShortName", info.alias);
            //法人
            this.subconChangeInfo.legalPersonName = info.legalPersonName;
            // historyNames String   曾用名
            this.$set(this.subconChangeInfo, "historyName", info.historyNames);
            // 币种 regCapitalCurrency
            /*this.$set(
                this.subconChangeInfo,
                "currency",
                info.regCapitalCurrency
              );*/
            if (info.creditCode) {
              this.extForm.unifiedCreditCode = info.creditCode;
            } else {
              this.extForm.unifiedCreditCode = "";
              this.extForm.supplierName = "";
            }
            if (this.extForm.unifiedCreditCode === "") {
              this.extForm.supplierName = "";
            }
          } else {
            this.extForm.unifiedCreditCode = "";
            this.extForm.supplierName = "";
            this.$message({
              showClose: true,
              type: "error",
              message: "信用代码查询失败",
              ccuiCustom: true,
            });
          }
        }
        if (this.extForm.unifiedCreditCode === "") {
          this.extForm.supplierName = "";
        } else {
          this.submitForm(formName);
        }
      });
      // if (this.extForm.unifiedCreditCode === "") {
      //   this.extForm.supplierName = "";
      // }else{
      //   this.submitForm(formName);
      // }
      /*setTimeout(
        if (this.extForm.unifiedCreditCode !== "") {
          //   this.extForm.supplierName = "";
          // }else{
          this.submitForm(formName);
        },2000)*/
    },
    // 提交第一步
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 校验验证码
          checkContactByMobile({
            mobile: this.extForm.phone,
            inputAuthCode: this.extForm.verificationCode,
          }).then((res) => {
            if (res.data.message === "成功") {
              this.extForm.createTime = "";
              this.extForm.updateTime = "";
              this.formLoading = true;
              this.extForm.authCertificate = "";
              registinformation(this.extForm).then(
                (res) => {
                  this.formLoading = false;
                  if (res.data.code === "0") {
                    this.extForm = Object.assign(
                      this.extForm,
                      res.data.data.subconAuthInfoRspBO
                    );
                    // this.extForm.cardType = this.extForm.cardType + "";
                    this.subconChangeInfo.cooUnitName =
                      this.extForm.cooUnitName;
                    this.subconChangeInfo.cooUnitCode =
                      this.extForm.cooUnitCode;
                    this.subconChangeInfo.cooUnitId = this.extForm.cooUnitId;
                    this.subconChangeInfo.subconName =
                      this.extForm.supplierName;
                    this.subconChangeInfo.unifiedCreditCode =
                      this.extForm.unifiedCreditCode;

                    if (res.data.data.subconChangeInfoRspBO) {
                      this.registerForm = Object.assign(
                        this.registerForm,
                        res.data.data.subconChangeInfoRspBO
                      );
                      this.registerForm.subconQualificationsChange.forEach(
                        (item) => {
                          this.$set(item, "vaildTime", [
                            item.vaildStart,
                            item.vaildEnd,
                          ]);
                        }
                      );
                      this.registerForm.subconDeviceInfoChange.forEach(
                        (item) => {
                          this.$set(item, "buyYearCopy", item.buyYear);
                        }
                      );
                      this.registerForm.subconManagePersonChange.forEach(
                        (item) => {
                          item.yesNo = item.yesNo === 0 ? "是" : "否";
                          item.cardType = item.cardType + "";
                        }
                      );
                      if (this.registerForm.subconChangeInfo.subconType) {
                        this.registerForm.subconChangeInfo.subconType =
                          this.registerForm.subconChangeInfo.subconType.split(
                            ","
                          );
                      } else {
                        this.registerForm.subconChangeInfo.subconType = [];
                      }
                      let { subconChangeInfo } = this.registerForm;
                      if (subconChangeInfo.county) {
                        this.$set(
                          this.registerForm.subconChangeInfo,
                          "inputValue",
                          subconChangeInfo.country +
                            "/" +
                            subconChangeInfo.province +
                            "/" +
                            subconChangeInfo.city +
                            "/" +
                            subconChangeInfo.county
                        );
                      } else if (subconChangeInfo.city) {
                        this.$set(
                          this.registerForm.subconChangeInfo,
                          "inputValue",
                          subconChangeInfo.country +
                            "/" +
                            subconChangeInfo.province +
                            "/" +
                            subconChangeInfo.city
                        );
                      } else if (subconChangeInfo.province) {
                        this.$set(
                          this.registerForm.subconChangeInfo,
                          "inputValue",
                          subconChangeInfo.country +
                            "/" +
                            subconChangeInfo.province
                        );
                      }
                      // 所在地
                      if (this.registerForm.subconChangeInfo.attribute2) {
                        this.registerForm.subconChangeInfo.countrys =
                          JSON.parse(
                            this.registerForm.subconChangeInfo.attribute2
                          );
                      }
                      this.registerForm.subconChangeInfo.yesNo =
                        this.registerForm.subconChangeInfo.yesNo === 0
                          ? "是"
                          : "否";
                      this.registerForm.subconChangeInfo.cardType =
                        this.registerForm.subconChangeInfo.cardType + "";
                      // if (
                      //   this.registerForm.subconAuthAccountInfo.cardType &&
                      //   this.registerForm.subconAuthAccountInfo.cardType.length
                      // ) {
                      //   this.registerForm.subconAuthAccountInfo.cardType =
                      //     this.registerForm.subconAuthAccountInfo.cardType + "";
                      // } else {
                      //   this.registerForm.subconAuthAccountInfo.cardType = " ";
                      // }
                      if (
                        this.registerForm.subconChangeInfo
                          .legalPersonCardValidityStart &&
                        this.registerForm.subconChangeInfo
                          .legalPersonCardValidityEnd
                      ) {
                        this.$set(
                          this.registerForm.subconChangeInfo,
                          "legalPersonCardValidityStart1",
                          [
                            this.registerForm.subconChangeInfo
                              .legalPersonCardValidityStart,
                            this.registerForm.subconChangeInfo
                              .legalPersonCardValidityEnd,
                          ]
                        );
                      }
                      this.$set(
                        this.registerForm.subconChangeInfo,
                        "companySetupTimeCopy",
                        this.registerForm.subconChangeInfo.companySetupTime
                      );
                      this.$set(
                        this.registerForm.subconChangeInfo,
                        "companySetupTime",
                        this.registerForm.subconChangeInfo.companySetupTime
                      );
                      this.registerForm.legalPersonCardValidityStart1 = [
                        subconChangeInfo.legalPersonCardValidityStart,
                        subconChangeInfo.legalPersonCardValidityEnd,
                      ];
                      if (
                        subconChangeInfo.safetyLicenseValidityStart &&
                        subconChangeInfo.safetyLicenseValidityEnd
                      ) {
                        this.$set(
                          this.registerForm.subconChangeInfo,
                          "safeTime",
                          [
                            subconChangeInfo.safetyLicenseValidityStart,
                            subconChangeInfo.safetyLicenseValidityEnd,
                          ]
                        );
                      }
                      if (
                        subconChangeInfo.businessStartTime &&
                        subconChangeInfo.businessEndTime
                      ) {
                        this.$set(
                          this.registerForm.subconChangeInfo,
                          "businessTime",
                          [
                            subconChangeInfo.businessStartTime,
                            subconChangeInfo.businessEndTime,
                          ]
                        );
                      }
                      this.$set(
                        this.registerForm.subconChangeInfo,
                        "taxpayerType",
                        subconChangeInfo.taxpayerType + ""
                      );
                      // 币种 regCapitalCurrency
                      this.$set(
                        this.registerForm.subconChangeInfo,
                        "currency",
                        subconChangeInfo.currency
                      );
                    }

                    this.registerForm.subconAuthAccountInfo.cardType =
                      this.registerForm.subconAuthAccountInfo.cardType + "";
                    this.extForm.createTime = "";
                    this.$emit("getStep", 1, true);
                  }
                },
                (error) => {
                  this.formLoading = false;
                }
              );
            }
          });
        } else {
          this.$emit("open");
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 验证码发送
    sendVerification() {
      this.disabled = true;
      if (this.extForm.phone && /^1\d{10}$/.test(this.extForm.phone)) {
        sendVerificationCode({ phoneNumbers: this.extForm.phone }).then(
          (res) => {
            if (res.data.message === "发送验证码成功") {
              this.$message({
                type: "success",
                message: res.data.message,
              });
              this.count = 60;
              let vClear = setInterval(() => {
                this.count--;
                if (this.count === 0) {
                  this.disabled = false;
                  this.count = "";
                  clearInterval(vClear);
                }
              }, 1000);
              return false;
            } else {
              this.disabled = false;
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          }
        );
      } else {
        this.disabled = false;
        this.$message({
          type: "error",
          message: "手机号码不正确",
        });
      }
    },
    getTreeItem() {
      this.centerDialogVisible = false;
      let treeItem = this.$refs["msgFormSon"].company;
      this.extForm.cooUnitName = treeItem.useOrgName;
      this.extForm.cooUnitCode = treeItem.useOrgCode;
      this.extForm.cooUnitId = treeItem.useOrgId;
    },
    searInpt(val) {
      this.loadWaite = true;
      qryTycSearch({ word: this.extForm.unifiedCreditCode }).then((res) => {
        this.loadWaite = false;
        if (res.data.code === "0") {
          this.extForm.unifiedCreditCode = "";
          this.extForm.supplierName = "";
          if (res.data.data.result) {
            const info = res.data.data.result;
            // 人员规模 staffNumRange
            this.$set(
              this.subconChangeInfo,
              "companySize",
              parseInt(info.staffNumRange)
            );
            // 成立日期
            this.$set(
              this.subconChangeInfo,
              "companySetupTime",
              formatDate(info.estiblishTime, "yyyy-MM-dd")
            );
            //fromTime Number 毫秒数 经营开始时间
            //toTime Number 毫秒数 经营结束时间
            this.$set(this.subconChangeInfo, "businessTime", [
              formatDate(info.fromTime, "yyyy-MM-dd"),
              formatDate(info.toTime, "yyyy-MM-dd"),
            ]);
            // 注册资本
            if (this.isdecimal(info.regCapital)) {
              this.subconChangeInfo.registeredCapital = info.regCapital.slice(
                0,
                info.regCapital.indexOf("万").toFixed(2)
              );
            } else {
              this.subconChangeInfo.registeredCapital = info.regCapital.slice(
                0,
                info.regCapital.indexOf("万")
              );
            }
            // actualCapital String   实收注册资金
            if (this.isdecimal(info.actualCapital)) {
              this.$set(
                this.subconChangeInfo,
                "paidInCapital",
                info.actualCapital.slice(
                  0,
                  info.regCapital.indexOf("万").toFixed(2)
                )
              );
            } else {
              this.$set(
                this.subconChangeInfo,
                "paidInCapital",
                info.actualCapital.slice(0, info.regCapital.indexOf("万"))
              );
            }
            // 企业名称
            this.extForm.supplierName = info.name;
            this.subconChangeInfo.subconName = info.name;
            // regLocation String   注册地址
            this.$set(
              this.subconChangeInfo,
              "registeredAddress",
              info.regLocation
            );
            // 经营范围
            this.$set(
              this.subconChangeInfo,
              "businessScope",
              info.businessScope
            );
            // 英文名
            this.$set(this.subconChangeInfo, "subconUsName", info.property3);
            // alias String   简称
            this.$set(this.subconChangeInfo, "subconShortName", info.alias);
            //法人
            this.subconChangeInfo.legalPersonName = info.legalPersonName;
            // historyNames String   曾用名
            this.$set(this.subconChangeInfo, "historyName", info.historyNames);
            // 币种 regCapitalCurrency
            /*this.$set(
                this.subconChangeInfo,
                "currency",
                info.regCapitalCurrency
              );*/
            if (info.creditCode) {
              this.extForm.unifiedCreditCode = info.creditCode;
            } else {
              this.extForm.unifiedCreditCode = "";
              this.extForm.supplierName = "";
            }
            if (this.extForm.unifiedCreditCode === "") {
              this.extForm.supplierName = "";
            }
          } else {
            this.extForm.unifiedCreditCode = "";
            this.extForm.supplierName = "";
            this.$message({
              showClose: true,
              type: "error",
              message: "信用代码查询失败",
              ccuiCustom: true,
            });
          }
        }
      });
    },
    // 级联选择器修改
    handleChange(value) {
      const obj = this.$refs["demoCascader"].getCheckedNodes();
      this.ruleForm.cooUnitName = obj[0].data.abbrName;
      this.ruleForm.cooUnitId = obj[0].data.orgId;
      this.ruleForm.cooUnitCode = obj[0].data.autoCode;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form /deep/.el-loading-spinner {
  margin-top: -90px;
  margin-left: -13px;
}
.el-input /deep/.el-loading-mask {
  background: rgba(0, 0, 0, 0.1);
}
.el-input /deep/.el-loading-spinner {
  left: 100%;
  top: 70px;
  img {
    width: 20px;
    height: 20px;
  }
}
.firstStep {
  display: flex;
  justify-content: center;
  align-items: center;
}
.firstStep .el-form {
  width: 75%;
  position: relative;
  left: -20px;
  .el-form-item {
    font-size: 14px !important;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85) !important;
    /deep/.el-form-item__label {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .el-form-item__content .el-input /deep/input,
  .el-select /deep/.el-input input {
    float: left;
    // width: 435px;
    height: 40px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #e9ecf7;
  }
  /deep/.el-cascader,
  /deep/.el-cascader .el-input .el-input__inner {
    height: 40px;
  }
  /deep/.el-cascader .el-input .el-icon-caret-bottom {
    line-height: 40px;
  }
  /deep/.el-form-item__content,
  /deep/.el-form-item__content .e-input {
    // width: 435px;
    height: 50px;
    .el-form-item__error {
      padding: 0;
    }
  }
  .el-form-item__content .el-button {
    width: 82px;
    height: 40px;
    background: #ff152e;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border: none;
    color: #ffffff;
  }
  .verificationCode {
    // width: 435px;
    display: flex;
    .el-button {
      width: 102px;
      height: 40px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #e9ecf7;
      margin-left: 15px;
    }
    .send {
      background: #fff !important;
      border: 1px solid #dddddd;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
